import Model from "../../../Model.js";
import periodReportColumnFactory from "./column/periodReportColumnFactory.js";
import ReportRow from "./ReportRow.js";

/**
 * `Report` contains rows, columns, and their associated values.
 *
 * @param {object[]} [spec.columns] - Columns of the report
 * @param {object[]} [spec.rows] - Rows of the report
 * @param {object[]} [spec.values] - Values of the report
 */
export default class Report extends Model {
	constructor({ columns, rows, values } = {}) {
		super(...arguments);

		this._columns = columns || [];
		this._rows = rows || [];
		this._values = values || [];

		this._rows.forEach((row) => {
			row.setReport(this);
		});

		this._columns.forEach((column) => {
			column.setReport(this);
		});
	}

	getRows() {
		return this._rows.slice();
	}

	getColumns() {
		return this._columns.slice();
	}

	getCell(options) {
		const column = options.column;
		const row = options.row;
		return this._values[this._getRowIndex(row)][
			this._getColumnIndex(column)
		];
	}

	shouldFormatInThousands() {
		return this._values.find((dataRow) =>
			dataRow.find(
				(value) => value >= 100_000_000 || value <= -100_000_000,
			),
		);
	}

	isEmpty() {
		return this._values.length === 0;
	}

	accept(visitor) {
		return visitor.visitReport(this);
	}

	_getRowIndex(row) {
		return this._rows.indexOf(row);
	}

	_getColumnIndex(column) {
		return this._columns.indexOf(column);
	}

	static transformMaterializationData(data, context) {
		data.columns = periodReportColumnFactory.materializeAll(
			data.columns,
			context,
		);

		data.rows = ReportRow.materializeAll(data.rows, context);
	}
}
